import GET_CATEGORIES from "../plugins/getCategories"

const init = () => {
  GET_CATEGORIES(`.news-catelist[data-plugin="getCategories"]`);
}

export default function NEWS() {
  $( init )
}